<template>
  <section class="section is-title-bar">
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <ul>
            <li>
              <router-link to="/">
                <b-icon icon="home-variant" />
              </router-link>
            </li>
            <li v-for="(title, index) in titleStack" :key="index">
              <div v-if="checkClickable(index)" class="title-bar-tag">
                <router-link
                  :to="title.url"
                  class="title-bar-router"
                  v-if="!title.page"
                >
                  <p class="title-bar-text-hover">
                    {{ title.name }}
                  </p>
                </router-link>
                <span class="title-bar-router" v-else>
                  <p
                    class="title-bar-text-hover"
                    @click="checkPage(title.page)"
                  >
                    {{ title.name }}
                  </p>
                </span>
              </div>
              <div v-else class="title-bar-tag">
                <span class="title-bar-text">{{ title.name }}</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @group General
export default {
  name: "TitleBar",
  props: {
    titleStack: {
      type: Array
    }
  },
  methods: {
    checkClickable(index) {
      if (index === 0 && this.titleStack.length > 1) {
        return true;
      }
      return false;
    },
    checkPage(pageName) {
      if (pageName == "overView") {
        this.$emit("loadOverView");
      }
    }
  }
};
</script>
